/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdvancedUserSearchResponse } from '../models';
// @ts-ignore
import type { AuthorAutoCompleteResponse } from '../models';
// @ts-ignore
import type { CurrencySymbolRepsonse } from '../models';
// @ts-ignore
import type { EmployerFeedbackBody } from '../models';
// @ts-ignore
import type { EmployerFeedbackStatusResponse } from '../models';
// @ts-ignore
import type { EntityId } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { FeedbackBody } from '../models';
// @ts-ignore
import type { FeedbackReplyBody } from '../models';
// @ts-ignore
import type { FeedbackResponse } from '../models';
// @ts-ignore
import type { FeedbackThreadResponse } from '../models';
// @ts-ignore
import type { GetBackendConstantsRepsonse } from '../models';
// @ts-ignore
import type { GetConstantValuesResponse } from '../models';
// @ts-ignore
import type { GetFeedbackReportsResponse } from '../models';
// @ts-ignore
import type { GetMyFeedbacksResponse } from '../models';
// @ts-ignore
import type { GetResumeListParams } from '../models';
// @ts-ignore
import type { GetResumeListResponse } from '../models';
// @ts-ignore
import type { GetUserListGeneralResponse } from '../models';
// @ts-ignore
import type { GetUserListParams } from '../models';
// @ts-ignore
import type { GetUserListResponse } from '../models';
// @ts-ignore
import type { LocationAutocompleteResponse } from '../models';
// @ts-ignore
import type { MergeDuplicateEntityBody } from '../models';
// @ts-ignore
import type { MergeDuplicateEntityResponse } from '../models';
// @ts-ignore
import type { PublicLandingStatsResponse } from '../models';
// @ts-ignore
import type { RewardEmployerFeedbackBody } from '../models';
// @ts-ignore
import type { RewardEmployerFeedbackResponse } from '../models';
// @ts-ignore
import type { SplitEntityBody } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UploadFeedbackResponse } from '../models';
// @ts-ignore
import type { UserGeoOptionsResponse } from '../models';
/**
 * GeneralApiApi - axios parameter creator
 */
export const GeneralApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiAcceptJobReferralVerificationRequest: async (feedbackId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feedbackId' is not null or undefined
            assertParamExists('generalApiAcceptJobReferralVerificationRequest', 'feedbackId', feedbackId)
            const localVarPath = `/admin/feedback/referral/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (feedbackId !== undefined) {
                localVarQueryParameter['feedback_id'] = feedbackId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} feedbackId 
         * @param {FeedbackReplyBody} feedbackReplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiAdminReplyToFeedback: async (feedbackId: string, feedbackReplyBody: FeedbackReplyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feedbackId' is not null or undefined
            assertParamExists('generalApiAdminReplyToFeedback', 'feedbackId', feedbackId)
            // verify required parameter 'feedbackReplyBody' is not null or undefined
            assertParamExists('generalApiAdminReplyToFeedback', 'feedbackReplyBody', feedbackReplyBody)
            const localVarPath = `/admin/feedback/{feedback_id}/reply`
                .replace('{feedback_id}', encodeURIComponent(String(feedbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(feedbackReplyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {EmployerFeedbackBody} employerFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiCreateEmployerFeedback: async (orgId: string, employerFeedbackBody: EmployerFeedbackBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('generalApiCreateEmployerFeedback', 'orgId', orgId)
            // verify required parameter 'employerFeedbackBody' is not null or undefined
            assertParamExists('generalApiCreateEmployerFeedback', 'employerFeedbackBody', employerFeedbackBody)
            const localVarPath = `/org/{org_id}/employer-feedback`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employerFeedbackBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FeedbackBody} feedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiCreateFeedbackReport: async (feedbackBody: FeedbackBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feedbackBody' is not null or undefined
            assertParamExists('generalApiCreateFeedbackReport', 'feedbackBody', feedbackBody)
            const localVarPath = `/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(feedbackBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetUserListParams} getUserListParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiDownloadAllUserList: async (getUserListParams: GetUserListParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getUserListParams' is not null or undefined
            assertParamExists('generalApiDownloadAllUserList', 'getUserListParams', getUserListParams)
            const localVarPath = `/admin/get-user-list/csv-download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getUserListParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetAdminFeedbackThread: async (feedbackId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feedbackId' is not null or undefined
            assertParamExists('generalApiGetAdminFeedbackThread', 'feedbackId', feedbackId)
            const localVarPath = `/admin/feedback/{feedback_id}`
                .replace('{feedback_id}', encodeURIComponent(String(feedbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetUserListParams} getUserListParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetAllUserList: async (getUserListParams: GetUserListParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getUserListParams' is not null or undefined
            assertParamExists('generalApiGetAllUserList', 'getUserListParams', getUserListParams)
            const localVarPath = `/admin/get-user-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getUserListParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetBackendConstants: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/constants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetConstantValues: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/constants/values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetCurrencySymbols: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/currency/symbols`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetEmployerFeedbackStatus: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('generalApiGetEmployerFeedbackStatus', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/employer-feedback/status`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [areaOfIssue] 
         * @param {string} [dateMax] 
         * @param {string} [dateMin] 
         * @param {string} [feedbackType] 
         * @param {string} [issueType] 
         * @param {string} [name] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [status] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetFeedbackReports: async (areaOfIssue?: string, dateMax?: string, dateMin?: string, feedbackType?: string, issueType?: string, name?: string, pageNo?: number, pageSize?: number, sortBy?: string, sortOrder?: string, status?: string, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (areaOfIssue !== undefined) {
                localVarQueryParameter['area_of_issue'] = areaOfIssue;
            }

            if (dateMax !== undefined) {
                localVarQueryParameter['date_max'] = dateMax;
            }

            if (dateMin !== undefined) {
                localVarQueryParameter['date_min'] = dateMin;
            }

            if (feedbackType !== undefined) {
                localVarQueryParameter['feedback_type'] = feedbackType;
            }

            if (issueType !== undefined) {
                localVarQueryParameter['issue_type'] = issueType;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetMyFeedbackThread: async (feedbackId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feedbackId' is not null or undefined
            assertParamExists('generalApiGetMyFeedbackThread', 'feedbackId', feedbackId)
            const localVarPath = `/feedback/{feedback_id}`
                .replace('{feedback_id}', encodeURIComponent(String(feedbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetResumeListParams} getResumeListParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetResumeCsv: async (getResumeListParams: GetResumeListParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getResumeListParams' is not null or undefined
            assertParamExists('generalApiGetResumeCsv', 'getResumeListParams', getResumeListParams)
            const localVarPath = `/admin/get-resume-list/csv-download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getResumeListParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetResumeListParams} getResumeListParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetResumeList: async (getResumeListParams: GetResumeListParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getResumeListParams' is not null or undefined
            assertParamExists('generalApiGetResumeList', 'getResumeListParams', getResumeListParams)
            const localVarPath = `/admin/get-resume-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getResumeListParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [maxJoinedOn] 
         * @param {string} [maxLastLoginDate] 
         * @param {number} [maxQuestionsCreated] 
         * @param {number} [maxReferrals] 
         * @param {string} [minJoinedOn] 
         * @param {string} [minLastLoginDate] 
         * @param {number} [minQuestionsCreated] 
         * @param {number} [minReferrals] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string | null} [skillId] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetUserDetailsList: async (firstName?: string, lastName?: string, maxJoinedOn?: string, maxLastLoginDate?: string, maxQuestionsCreated?: number, maxReferrals?: number, minJoinedOn?: string, minLastLoginDate?: string, minQuestionsCreated?: number, minReferrals?: number, pageNo?: number, pageSize?: number, skillId?: string | null, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/user-detail-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (firstName !== undefined) {
                localVarQueryParameter['first_name'] = firstName;
            }

            if (lastName !== undefined) {
                localVarQueryParameter['last_name'] = lastName;
            }

            if (maxJoinedOn !== undefined) {
                localVarQueryParameter['max_joined_on'] = maxJoinedOn;
            }

            if (maxLastLoginDate !== undefined) {
                localVarQueryParameter['max_last_login_date'] = maxLastLoginDate;
            }

            if (maxQuestionsCreated !== undefined) {
                localVarQueryParameter['max_questions_created'] = maxQuestionsCreated;
            }

            if (maxReferrals !== undefined) {
                localVarQueryParameter['max_referrals'] = maxReferrals;
            }

            if (minJoinedOn !== undefined) {
                localVarQueryParameter['min_joined_on'] = minJoinedOn;
            }

            if (minLastLoginDate !== undefined) {
                localVarQueryParameter['min_last_login_date'] = minLastLoginDate;
            }

            if (minQuestionsCreated !== undefined) {
                localVarQueryParameter['min_questions_created'] = minQuestionsCreated;
            }

            if (minReferrals !== undefined) {
                localVarQueryParameter['min_referrals'] = minReferrals;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (skillId !== undefined) {
                localVarQueryParameter['skill_id'] = skillId;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetUserGeoOptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/get-user-list/geo-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [competitionId] 
         * @param {number} [inactiveSince] 
         * @param {number} [maxAccuracy] 
         * @param {number} [maxCategoryLevel] 
         * @param {number} [maxCredits] 
         * @param {number} [maxRank] 
         * @param {number} [maxScore] 
         * @param {number} [minAccuracy] 
         * @param {number} [minCategoryLevel] 
         * @param {number} [minCredits] 
         * @param {number} [minRank] 
         * @param {number} [minScore] 
         * @param {string} [nameQuery] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string | null} [skillId] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetUsersWithAdvancedSearch: async (competitionId?: string, inactiveSince?: number, maxAccuracy?: number, maxCategoryLevel?: number, maxCredits?: number, maxRank?: number, maxScore?: number, minAccuracy?: number, minCategoryLevel?: number, minCredits?: number, minRank?: number, minScore?: number, nameQuery?: string, pageNo?: number, pageSize?: number, skillId?: string | null, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/advanced-user-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (competitionId !== undefined) {
                localVarQueryParameter['competition_id'] = competitionId;
            }

            if (inactiveSince !== undefined) {
                localVarQueryParameter['inactive_since'] = inactiveSince;
            }

            if (maxAccuracy !== undefined) {
                localVarQueryParameter['max_accuracy'] = maxAccuracy;
            }

            if (maxCategoryLevel !== undefined) {
                localVarQueryParameter['max_category_level'] = maxCategoryLevel;
            }

            if (maxCredits !== undefined) {
                localVarQueryParameter['max_credits'] = maxCredits;
            }

            if (maxRank !== undefined) {
                localVarQueryParameter['max_rank'] = maxRank;
            }

            if (maxScore !== undefined) {
                localVarQueryParameter['max_score'] = maxScore;
            }

            if (minAccuracy !== undefined) {
                localVarQueryParameter['min_accuracy'] = minAccuracy;
            }

            if (minCategoryLevel !== undefined) {
                localVarQueryParameter['min_category_level'] = minCategoryLevel;
            }

            if (minCredits !== undefined) {
                localVarQueryParameter['min_credits'] = minCredits;
            }

            if (minRank !== undefined) {
                localVarQueryParameter['min_rank'] = minRank;
            }

            if (minScore !== undefined) {
                localVarQueryParameter['min_score'] = minScore;
            }

            if (nameQuery !== undefined) {
                localVarQueryParameter['name_query'] = nameQuery;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (skillId !== undefined) {
                localVarQueryParameter['skill_id'] = skillId;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiHealthCheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/healthz`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiListMyFeedbacks: async (pageNo?: number, pageSize?: number, status?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/feedback/mine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiLocationAutocomplete: async (searchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/location/autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MergeDuplicateEntityBody} mergeDuplicateEntityBody 
         * @param {string} [entityType] 
         * @param {string} [mainEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiMergeSimilarOrDuplicateEnitites: async (mergeDuplicateEntityBody: MergeDuplicateEntityBody, entityType?: string, mainEntityId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mergeDuplicateEntityBody' is not null or undefined
            assertParamExists('generalApiMergeSimilarOrDuplicateEnitites', 'mergeDuplicateEntityBody', mergeDuplicateEntityBody)
            const localVarPath = `/admin/merge-duplicates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (entityType !== undefined) {
                localVarQueryParameter['entity_type'] = entityType;
            }

            if (mainEntityId !== undefined) {
                localVarQueryParameter['main_entity_id'] = mainEntityId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mergeDuplicateEntityBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiPublicLandingStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/landing-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {string} [query] 
         * @param {string | null} [skillId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiQuestionAuthorAutocomplete: async (page?: string, pageSize?: string, query?: string, skillId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/author/autocomplete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (skillId !== undefined) {
                localVarQueryParameter['skill_id'] = skillId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} feedbackId 
         * @param {FeedbackReplyBody} feedbackReplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiReplyToMyFeedback: async (feedbackId: string, feedbackReplyBody: FeedbackReplyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feedbackId' is not null or undefined
            assertParamExists('generalApiReplyToMyFeedback', 'feedbackId', feedbackId)
            // verify required parameter 'feedbackReplyBody' is not null or undefined
            assertParamExists('generalApiReplyToMyFeedback', 'feedbackReplyBody', feedbackReplyBody)
            const localVarPath = `/feedback/{feedback_id}/reply`
                .replace('{feedback_id}', encodeURIComponent(String(feedbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(feedbackReplyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} feedbackId 
         * @param {RewardEmployerFeedbackBody} rewardEmployerFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiRewardEmployerFeedback: async (feedbackId: string, rewardEmployerFeedbackBody: RewardEmployerFeedbackBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feedbackId' is not null or undefined
            assertParamExists('generalApiRewardEmployerFeedback', 'feedbackId', feedbackId)
            // verify required parameter 'rewardEmployerFeedbackBody' is not null or undefined
            assertParamExists('generalApiRewardEmployerFeedback', 'rewardEmployerFeedbackBody', rewardEmployerFeedbackBody)
            const localVarPath = `/admin/feedback/{feedback_id}/reward-employer`
                .replace('{feedback_id}', encodeURIComponent(String(feedbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rewardEmployerFeedbackBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiSendAbekusCoreFiles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/abekus-core/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SplitEntityBody} splitEntityBody 
         * @param {string} [entityType] 
         * @param {string} [mainEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiSplitEntities: async (splitEntityBody: SplitEntityBody, entityType?: string, mainEntityId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'splitEntityBody' is not null or undefined
            assertParamExists('generalApiSplitEntities', 'splitEntityBody', splitEntityBody)
            const localVarPath = `/admin/split-entities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (entityType !== undefined) {
                localVarQueryParameter['entity_type'] = entityType;
            }

            if (mainEntityId !== undefined) {
                localVarQueryParameter['main_entity_id'] = mainEntityId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(splitEntityBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} queueName 
         * @param {string} taskName 
         * @param {EntityId} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiTestCoreTask: async (queueName: string, taskName: string, entityId: EntityId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'queueName' is not null or undefined
            assertParamExists('generalApiTestCoreTask', 'queueName', queueName)
            // verify required parameter 'taskName' is not null or undefined
            assertParamExists('generalApiTestCoreTask', 'taskName', taskName)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('generalApiTestCoreTask', 'entityId', entityId)
            const localVarPath = `/admin/abekus-core/task/{task_name}/{queue_name}`
                .replace('{queue_name}', encodeURIComponent(String(queueName)))
                .replace('{task_name}', encodeURIComponent(String(taskName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityId, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [feedbackId] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiUpdateUserFeedbackStatus: async (feedbackId?: string, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (feedbackId !== undefined) {
                localVarQueryParameter['feedback_id'] = feedbackId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} mediaFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiUploadFeedbackMedia: async (mediaFile: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mediaFile' is not null or undefined
            assertParamExists('generalApiUploadFeedbackMedia', 'mediaFile', mediaFile)
            const localVarPath = `/feedback/upload-media`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (mediaFile !== undefined) { 
                localVarFormParams.append('media_file', mediaFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralApiApi - functional programming interface
 */
export const GeneralApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiAcceptJobReferralVerificationRequest(feedbackId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiAcceptJobReferralVerificationRequest(feedbackId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiAcceptJobReferralVerificationRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} feedbackId 
         * @param {FeedbackReplyBody} feedbackReplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiAdminReplyToFeedback(feedbackId: string, feedbackReplyBody: FeedbackReplyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedbackThreadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiAdminReplyToFeedback(feedbackId, feedbackReplyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiAdminReplyToFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {EmployerFeedbackBody} employerFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiCreateEmployerFeedback(orgId: string, employerFeedbackBody: EmployerFeedbackBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployerFeedbackStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiCreateEmployerFeedback(orgId, employerFeedbackBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiCreateEmployerFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FeedbackBody} feedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiCreateFeedbackReport(feedbackBody: FeedbackBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiCreateFeedbackReport(feedbackBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiCreateFeedbackReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetUserListParams} getUserListParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiDownloadAllUserList(getUserListParams: GetUserListParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiDownloadAllUserList(getUserListParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiDownloadAllUserList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiGetAdminFeedbackThread(feedbackId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedbackThreadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiGetAdminFeedbackThread(feedbackId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiGetAdminFeedbackThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetUserListParams} getUserListParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiGetAllUserList(getUserListParams: GetUserListParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiGetAllUserList(getUserListParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiGetAllUserList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiGetBackendConstants(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBackendConstantsRepsonse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiGetBackendConstants(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiGetBackendConstants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiGetConstantValues(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetConstantValuesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiGetConstantValues(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiGetConstantValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiGetCurrencySymbols(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrencySymbolRepsonse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiGetCurrencySymbols(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiGetCurrencySymbols']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiGetEmployerFeedbackStatus(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployerFeedbackStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiGetEmployerFeedbackStatus(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiGetEmployerFeedbackStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [areaOfIssue] 
         * @param {string} [dateMax] 
         * @param {string} [dateMin] 
         * @param {string} [feedbackType] 
         * @param {string} [issueType] 
         * @param {string} [name] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [status] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiGetFeedbackReports(areaOfIssue?: string, dateMax?: string, dateMin?: string, feedbackType?: string, issueType?: string, name?: string, pageNo?: number, pageSize?: number, sortBy?: string, sortOrder?: string, status?: string, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFeedbackReportsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiGetFeedbackReports(areaOfIssue, dateMax, dateMin, feedbackType, issueType, name, pageNo, pageSize, sortBy, sortOrder, status, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiGetFeedbackReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiGetMyFeedbackThread(feedbackId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedbackThreadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiGetMyFeedbackThread(feedbackId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiGetMyFeedbackThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetResumeListParams} getResumeListParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiGetResumeCsv(getResumeListParams: GetResumeListParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiGetResumeCsv(getResumeListParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiGetResumeCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetResumeListParams} getResumeListParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiGetResumeList(getResumeListParams: GetResumeListParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetResumeListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiGetResumeList(getResumeListParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiGetResumeList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [maxJoinedOn] 
         * @param {string} [maxLastLoginDate] 
         * @param {number} [maxQuestionsCreated] 
         * @param {number} [maxReferrals] 
         * @param {string} [minJoinedOn] 
         * @param {string} [minLastLoginDate] 
         * @param {number} [minQuestionsCreated] 
         * @param {number} [minReferrals] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string | null} [skillId] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiGetUserDetailsList(firstName?: string, lastName?: string, maxJoinedOn?: string, maxLastLoginDate?: string, maxQuestionsCreated?: number, maxReferrals?: number, minJoinedOn?: string, minLastLoginDate?: string, minQuestionsCreated?: number, minReferrals?: number, pageNo?: number, pageSize?: number, skillId?: string | null, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserListGeneralResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiGetUserDetailsList(firstName, lastName, maxJoinedOn, maxLastLoginDate, maxQuestionsCreated, maxReferrals, minJoinedOn, minLastLoginDate, minQuestionsCreated, minReferrals, pageNo, pageSize, skillId, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiGetUserDetailsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiGetUserGeoOptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGeoOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiGetUserGeoOptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiGetUserGeoOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [competitionId] 
         * @param {number} [inactiveSince] 
         * @param {number} [maxAccuracy] 
         * @param {number} [maxCategoryLevel] 
         * @param {number} [maxCredits] 
         * @param {number} [maxRank] 
         * @param {number} [maxScore] 
         * @param {number} [minAccuracy] 
         * @param {number} [minCategoryLevel] 
         * @param {number} [minCredits] 
         * @param {number} [minRank] 
         * @param {number} [minScore] 
         * @param {string} [nameQuery] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string | null} [skillId] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiGetUsersWithAdvancedSearch(competitionId?: string, inactiveSince?: number, maxAccuracy?: number, maxCategoryLevel?: number, maxCredits?: number, maxRank?: number, maxScore?: number, minAccuracy?: number, minCategoryLevel?: number, minCredits?: number, minRank?: number, minScore?: number, nameQuery?: string, pageNo?: number, pageSize?: number, skillId?: string | null, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvancedUserSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiGetUsersWithAdvancedSearch(competitionId, inactiveSince, maxAccuracy, maxCategoryLevel, maxCredits, maxRank, maxScore, minAccuracy, minCategoryLevel, minCredits, minRank, minScore, nameQuery, pageNo, pageSize, skillId, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiGetUsersWithAdvancedSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiHealthCheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiHealthCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiHealthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiListMyFeedbacks(pageNo?: number, pageSize?: number, status?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMyFeedbacksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiListMyFeedbacks(pageNo, pageSize, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiListMyFeedbacks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiLocationAutocomplete(searchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationAutocompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiLocationAutocomplete(searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiLocationAutocomplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MergeDuplicateEntityBody} mergeDuplicateEntityBody 
         * @param {string} [entityType] 
         * @param {string} [mainEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiMergeSimilarOrDuplicateEnitites(mergeDuplicateEntityBody: MergeDuplicateEntityBody, entityType?: string, mainEntityId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MergeDuplicateEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiMergeSimilarOrDuplicateEnitites(mergeDuplicateEntityBody, entityType, mainEntityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiMergeSimilarOrDuplicateEnitites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiPublicLandingStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicLandingStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiPublicLandingStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiPublicLandingStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {string} [query] 
         * @param {string | null} [skillId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiQuestionAuthorAutocomplete(page?: string, pageSize?: string, query?: string, skillId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorAutoCompleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiQuestionAuthorAutocomplete(page, pageSize, query, skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiQuestionAuthorAutocomplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} feedbackId 
         * @param {FeedbackReplyBody} feedbackReplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiReplyToMyFeedback(feedbackId: string, feedbackReplyBody: FeedbackReplyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedbackThreadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiReplyToMyFeedback(feedbackId, feedbackReplyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiReplyToMyFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} feedbackId 
         * @param {RewardEmployerFeedbackBody} rewardEmployerFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiRewardEmployerFeedback(feedbackId: string, rewardEmployerFeedbackBody: RewardEmployerFeedbackBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RewardEmployerFeedbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiRewardEmployerFeedback(feedbackId, rewardEmployerFeedbackBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiRewardEmployerFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiSendAbekusCoreFiles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiSendAbekusCoreFiles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiSendAbekusCoreFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SplitEntityBody} splitEntityBody 
         * @param {string} [entityType] 
         * @param {string} [mainEntityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiSplitEntities(splitEntityBody: SplitEntityBody, entityType?: string, mainEntityId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MergeDuplicateEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiSplitEntities(splitEntityBody, entityType, mainEntityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiSplitEntities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} queueName 
         * @param {string} taskName 
         * @param {EntityId} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiTestCoreTask(queueName: string, taskName: string, entityId: EntityId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiTestCoreTask(queueName, taskName, entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiTestCoreTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [feedbackId] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiUpdateUserFeedbackStatus(feedbackId?: string, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiUpdateUserFeedbackStatus(feedbackId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiUpdateUserFeedbackStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} mediaFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalApiUploadFeedbackMedia(mediaFile: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadFeedbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalApiUploadFeedbackMedia(mediaFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralApiApi.generalApiUploadFeedbackMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeneralApiApi - factory interface
 */
export const GeneralApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralApiApiFp(configuration)
    return {
        /**
         * 
         * @param {GeneralApiApiGeneralApiAcceptJobReferralVerificationRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiAcceptJobReferralVerificationRequest(requestParameters: GeneralApiApiGeneralApiAcceptJobReferralVerificationRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<FeedbackResponse> {
            return localVarFp.generalApiAcceptJobReferralVerificationRequest(requestParameters.feedbackId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiAdminReplyToFeedbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiAdminReplyToFeedback(requestParameters: GeneralApiApiGeneralApiAdminReplyToFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<FeedbackThreadResponse> {
            return localVarFp.generalApiAdminReplyToFeedback(requestParameters.feedbackId, requestParameters.feedbackReplyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiCreateEmployerFeedbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiCreateEmployerFeedback(requestParameters: GeneralApiApiGeneralApiCreateEmployerFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployerFeedbackStatusResponse> {
            return localVarFp.generalApiCreateEmployerFeedback(requestParameters.orgId, requestParameters.employerFeedbackBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiCreateFeedbackReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiCreateFeedbackReport(requestParameters: GeneralApiApiGeneralApiCreateFeedbackReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<FeedbackResponse> {
            return localVarFp.generalApiCreateFeedbackReport(requestParameters.feedbackBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiDownloadAllUserListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiDownloadAllUserList(requestParameters: GeneralApiApiGeneralApiDownloadAllUserListRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generalApiDownloadAllUserList(requestParameters.getUserListParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiGetAdminFeedbackThreadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetAdminFeedbackThread(requestParameters: GeneralApiApiGeneralApiGetAdminFeedbackThreadRequest, options?: RawAxiosRequestConfig): AxiosPromise<FeedbackThreadResponse> {
            return localVarFp.generalApiGetAdminFeedbackThread(requestParameters.feedbackId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiGetAllUserListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetAllUserList(requestParameters: GeneralApiApiGeneralApiGetAllUserListRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUserListResponse> {
            return localVarFp.generalApiGetAllUserList(requestParameters.getUserListParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetBackendConstants(options?: RawAxiosRequestConfig): AxiosPromise<GetBackendConstantsRepsonse> {
            return localVarFp.generalApiGetBackendConstants(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetConstantValues(options?: RawAxiosRequestConfig): AxiosPromise<GetConstantValuesResponse> {
            return localVarFp.generalApiGetConstantValues(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetCurrencySymbols(options?: RawAxiosRequestConfig): AxiosPromise<CurrencySymbolRepsonse> {
            return localVarFp.generalApiGetCurrencySymbols(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiGetEmployerFeedbackStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetEmployerFeedbackStatus(requestParameters: GeneralApiApiGeneralApiGetEmployerFeedbackStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployerFeedbackStatusResponse> {
            return localVarFp.generalApiGetEmployerFeedbackStatus(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiGetFeedbackReportsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetFeedbackReports(requestParameters: GeneralApiApiGeneralApiGetFeedbackReportsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetFeedbackReportsResponse> {
            return localVarFp.generalApiGetFeedbackReports(requestParameters.areaOfIssue, requestParameters.dateMax, requestParameters.dateMin, requestParameters.feedbackType, requestParameters.issueType, requestParameters.name, requestParameters.pageNo, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.status, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiGetMyFeedbackThreadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetMyFeedbackThread(requestParameters: GeneralApiApiGeneralApiGetMyFeedbackThreadRequest, options?: RawAxiosRequestConfig): AxiosPromise<FeedbackThreadResponse> {
            return localVarFp.generalApiGetMyFeedbackThread(requestParameters.feedbackId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiGetResumeCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetResumeCsv(requestParameters: GeneralApiApiGeneralApiGetResumeCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generalApiGetResumeCsv(requestParameters.getResumeListParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiGetResumeListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetResumeList(requestParameters: GeneralApiApiGeneralApiGetResumeListRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetResumeListResponse> {
            return localVarFp.generalApiGetResumeList(requestParameters.getResumeListParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiGetUserDetailsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetUserDetailsList(requestParameters: GeneralApiApiGeneralApiGetUserDetailsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetUserListGeneralResponse> {
            return localVarFp.generalApiGetUserDetailsList(requestParameters.firstName, requestParameters.lastName, requestParameters.maxJoinedOn, requestParameters.maxLastLoginDate, requestParameters.maxQuestionsCreated, requestParameters.maxReferrals, requestParameters.minJoinedOn, requestParameters.minLastLoginDate, requestParameters.minQuestionsCreated, requestParameters.minReferrals, requestParameters.pageNo, requestParameters.pageSize, requestParameters.skillId, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetUserGeoOptions(options?: RawAxiosRequestConfig): AxiosPromise<UserGeoOptionsResponse> {
            return localVarFp.generalApiGetUserGeoOptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiGetUsersWithAdvancedSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiGetUsersWithAdvancedSearch(requestParameters: GeneralApiApiGeneralApiGetUsersWithAdvancedSearchRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdvancedUserSearchResponse> {
            return localVarFp.generalApiGetUsersWithAdvancedSearch(requestParameters.competitionId, requestParameters.inactiveSince, requestParameters.maxAccuracy, requestParameters.maxCategoryLevel, requestParameters.maxCredits, requestParameters.maxRank, requestParameters.maxScore, requestParameters.minAccuracy, requestParameters.minCategoryLevel, requestParameters.minCredits, requestParameters.minRank, requestParameters.minScore, requestParameters.nameQuery, requestParameters.pageNo, requestParameters.pageSize, requestParameters.skillId, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiHealthCheck(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.generalApiHealthCheck(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiListMyFeedbacksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiListMyFeedbacks(requestParameters: GeneralApiApiGeneralApiListMyFeedbacksRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetMyFeedbacksResponse> {
            return localVarFp.generalApiListMyFeedbacks(requestParameters.pageNo, requestParameters.pageSize, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiLocationAutocompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiLocationAutocomplete(requestParameters: GeneralApiApiGeneralApiLocationAutocompleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LocationAutocompleteResponse> {
            return localVarFp.generalApiLocationAutocomplete(requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiMergeSimilarOrDuplicateEnititesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiMergeSimilarOrDuplicateEnitites(requestParameters: GeneralApiApiGeneralApiMergeSimilarOrDuplicateEnititesRequest, options?: RawAxiosRequestConfig): AxiosPromise<MergeDuplicateEntityResponse> {
            return localVarFp.generalApiMergeSimilarOrDuplicateEnitites(requestParameters.mergeDuplicateEntityBody, requestParameters.entityType, requestParameters.mainEntityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiPublicLandingStats(options?: RawAxiosRequestConfig): AxiosPromise<PublicLandingStatsResponse> {
            return localVarFp.generalApiPublicLandingStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiQuestionAuthorAutocompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiQuestionAuthorAutocomplete(requestParameters: GeneralApiApiGeneralApiQuestionAuthorAutocompleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AuthorAutoCompleteResponse> {
            return localVarFp.generalApiQuestionAuthorAutocomplete(requestParameters.page, requestParameters.pageSize, requestParameters.query, requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiReplyToMyFeedbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiReplyToMyFeedback(requestParameters: GeneralApiApiGeneralApiReplyToMyFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<FeedbackThreadResponse> {
            return localVarFp.generalApiReplyToMyFeedback(requestParameters.feedbackId, requestParameters.feedbackReplyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiRewardEmployerFeedbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiRewardEmployerFeedback(requestParameters: GeneralApiApiGeneralApiRewardEmployerFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<RewardEmployerFeedbackResponse> {
            return localVarFp.generalApiRewardEmployerFeedback(requestParameters.feedbackId, requestParameters.rewardEmployerFeedbackBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiSendAbekusCoreFiles(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generalApiSendAbekusCoreFiles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiSplitEntitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiSplitEntities(requestParameters: GeneralApiApiGeneralApiSplitEntitiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<MergeDuplicateEntityResponse> {
            return localVarFp.generalApiSplitEntities(requestParameters.splitEntityBody, requestParameters.entityType, requestParameters.mainEntityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiTestCoreTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiTestCoreTask(requestParameters: GeneralApiApiGeneralApiTestCoreTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generalApiTestCoreTask(requestParameters.queueName, requestParameters.taskName, requestParameters.entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiUpdateUserFeedbackStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiUpdateUserFeedbackStatus(requestParameters: GeneralApiApiGeneralApiUpdateUserFeedbackStatusRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<FeedbackResponse> {
            return localVarFp.generalApiUpdateUserFeedbackStatus(requestParameters.feedbackId, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralApiApiGeneralApiUploadFeedbackMediaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalApiUploadFeedbackMedia(requestParameters: GeneralApiApiGeneralApiUploadFeedbackMediaRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadFeedbackResponse> {
            return localVarFp.generalApiUploadFeedbackMedia(requestParameters.mediaFile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for generalApiAcceptJobReferralVerificationRequest operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiAcceptJobReferralVerificationRequestRequest {
    readonly feedbackId: string
}

/**
 * Request parameters for generalApiAdminReplyToFeedback operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiAdminReplyToFeedbackRequest {
    readonly feedbackId: string

    readonly feedbackReplyBody: FeedbackReplyBody
}

/**
 * Request parameters for generalApiCreateEmployerFeedback operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiCreateEmployerFeedbackRequest {
    readonly orgId: string

    readonly employerFeedbackBody: EmployerFeedbackBody
}

/**
 * Request parameters for generalApiCreateFeedbackReport operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiCreateFeedbackReportRequest {
    readonly feedbackBody: FeedbackBody
}

/**
 * Request parameters for generalApiDownloadAllUserList operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiDownloadAllUserListRequest {
    readonly getUserListParams: GetUserListParams
}

/**
 * Request parameters for generalApiGetAdminFeedbackThread operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiGetAdminFeedbackThreadRequest {
    readonly feedbackId: string
}

/**
 * Request parameters for generalApiGetAllUserList operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiGetAllUserListRequest {
    readonly getUserListParams: GetUserListParams
}

/**
 * Request parameters for generalApiGetEmployerFeedbackStatus operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiGetEmployerFeedbackStatusRequest {
    readonly orgId: string
}

/**
 * Request parameters for generalApiGetFeedbackReports operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiGetFeedbackReportsRequest {
    readonly areaOfIssue?: string

    readonly dateMax?: string

    readonly dateMin?: string

    readonly feedbackType?: string

    readonly issueType?: string

    readonly name?: string

    readonly pageNo?: number

    readonly pageSize?: number

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly status?: string

    readonly userId?: string
}

/**
 * Request parameters for generalApiGetMyFeedbackThread operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiGetMyFeedbackThreadRequest {
    readonly feedbackId: string
}

/**
 * Request parameters for generalApiGetResumeCsv operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiGetResumeCsvRequest {
    readonly getResumeListParams: GetResumeListParams
}

/**
 * Request parameters for generalApiGetResumeList operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiGetResumeListRequest {
    readonly getResumeListParams: GetResumeListParams
}

/**
 * Request parameters for generalApiGetUserDetailsList operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiGetUserDetailsListRequest {
    readonly firstName?: string

    readonly lastName?: string

    readonly maxJoinedOn?: string

    readonly maxLastLoginDate?: string

    readonly maxQuestionsCreated?: number

    readonly maxReferrals?: number

    readonly minJoinedOn?: string

    readonly minLastLoginDate?: string

    readonly minQuestionsCreated?: number

    readonly minReferrals?: number

    readonly pageNo?: number

    readonly pageSize?: number

    readonly skillId?: string | null

    readonly userType?: string
}

/**
 * Request parameters for generalApiGetUsersWithAdvancedSearch operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiGetUsersWithAdvancedSearchRequest {
    readonly competitionId?: string

    readonly inactiveSince?: number

    readonly maxAccuracy?: number

    readonly maxCategoryLevel?: number

    readonly maxCredits?: number

    readonly maxRank?: number

    readonly maxScore?: number

    readonly minAccuracy?: number

    readonly minCategoryLevel?: number

    readonly minCredits?: number

    readonly minRank?: number

    readonly minScore?: number

    readonly nameQuery?: string

    readonly pageNo?: number

    readonly pageSize?: number

    readonly skillId?: string | null

    readonly sortBy?: string

    readonly sortOrder?: string
}

/**
 * Request parameters for generalApiListMyFeedbacks operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiListMyFeedbacksRequest {
    readonly pageNo?: number

    readonly pageSize?: number

    readonly status?: string | null
}

/**
 * Request parameters for generalApiLocationAutocomplete operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiLocationAutocompleteRequest {
    readonly searchQuery?: string
}

/**
 * Request parameters for generalApiMergeSimilarOrDuplicateEnitites operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiMergeSimilarOrDuplicateEnititesRequest {
    readonly mergeDuplicateEntityBody: MergeDuplicateEntityBody

    readonly entityType?: string

    readonly mainEntityId?: string
}

/**
 * Request parameters for generalApiQuestionAuthorAutocomplete operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiQuestionAuthorAutocompleteRequest {
    readonly page?: string

    readonly pageSize?: string

    readonly query?: string

    readonly skillId?: string | null
}

/**
 * Request parameters for generalApiReplyToMyFeedback operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiReplyToMyFeedbackRequest {
    readonly feedbackId: string

    readonly feedbackReplyBody: FeedbackReplyBody
}

/**
 * Request parameters for generalApiRewardEmployerFeedback operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiRewardEmployerFeedbackRequest {
    readonly feedbackId: string

    readonly rewardEmployerFeedbackBody: RewardEmployerFeedbackBody
}

/**
 * Request parameters for generalApiSplitEntities operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiSplitEntitiesRequest {
    readonly splitEntityBody: SplitEntityBody

    readonly entityType?: string

    readonly mainEntityId?: string
}

/**
 * Request parameters for generalApiTestCoreTask operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiTestCoreTaskRequest {
    readonly queueName: string

    readonly taskName: string

    readonly entityId: EntityId
}

/**
 * Request parameters for generalApiUpdateUserFeedbackStatus operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiUpdateUserFeedbackStatusRequest {
    readonly feedbackId?: string

    readonly status?: string
}

/**
 * Request parameters for generalApiUploadFeedbackMedia operation in GeneralApiApi.
 */
export interface GeneralApiApiGeneralApiUploadFeedbackMediaRequest {
    readonly mediaFile: File
}

/**
 * GeneralApiApi - object-oriented interface
 */
export class GeneralApiApi extends BaseAPI {
    /**
     * 
     * @param {GeneralApiApiGeneralApiAcceptJobReferralVerificationRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiAcceptJobReferralVerificationRequest(requestParameters: GeneralApiApiGeneralApiAcceptJobReferralVerificationRequestRequest, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiAcceptJobReferralVerificationRequest(requestParameters.feedbackId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiAdminReplyToFeedbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiAdminReplyToFeedback(requestParameters: GeneralApiApiGeneralApiAdminReplyToFeedbackRequest, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiAdminReplyToFeedback(requestParameters.feedbackId, requestParameters.feedbackReplyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiCreateEmployerFeedbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiCreateEmployerFeedback(requestParameters: GeneralApiApiGeneralApiCreateEmployerFeedbackRequest, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiCreateEmployerFeedback(requestParameters.orgId, requestParameters.employerFeedbackBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiCreateFeedbackReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiCreateFeedbackReport(requestParameters: GeneralApiApiGeneralApiCreateFeedbackReportRequest, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiCreateFeedbackReport(requestParameters.feedbackBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiDownloadAllUserListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiDownloadAllUserList(requestParameters: GeneralApiApiGeneralApiDownloadAllUserListRequest, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiDownloadAllUserList(requestParameters.getUserListParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiGetAdminFeedbackThreadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiGetAdminFeedbackThread(requestParameters: GeneralApiApiGeneralApiGetAdminFeedbackThreadRequest, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiGetAdminFeedbackThread(requestParameters.feedbackId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiGetAllUserListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiGetAllUserList(requestParameters: GeneralApiApiGeneralApiGetAllUserListRequest, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiGetAllUserList(requestParameters.getUserListParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiGetBackendConstants(options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiGetBackendConstants(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiGetConstantValues(options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiGetConstantValues(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiGetCurrencySymbols(options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiGetCurrencySymbols(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiGetEmployerFeedbackStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiGetEmployerFeedbackStatus(requestParameters: GeneralApiApiGeneralApiGetEmployerFeedbackStatusRequest, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiGetEmployerFeedbackStatus(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiGetFeedbackReportsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiGetFeedbackReports(requestParameters: GeneralApiApiGeneralApiGetFeedbackReportsRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiGetFeedbackReports(requestParameters.areaOfIssue, requestParameters.dateMax, requestParameters.dateMin, requestParameters.feedbackType, requestParameters.issueType, requestParameters.name, requestParameters.pageNo, requestParameters.pageSize, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.status, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiGetMyFeedbackThreadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiGetMyFeedbackThread(requestParameters: GeneralApiApiGeneralApiGetMyFeedbackThreadRequest, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiGetMyFeedbackThread(requestParameters.feedbackId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiGetResumeCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiGetResumeCsv(requestParameters: GeneralApiApiGeneralApiGetResumeCsvRequest, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiGetResumeCsv(requestParameters.getResumeListParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiGetResumeListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiGetResumeList(requestParameters: GeneralApiApiGeneralApiGetResumeListRequest, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiGetResumeList(requestParameters.getResumeListParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiGetUserDetailsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiGetUserDetailsList(requestParameters: GeneralApiApiGeneralApiGetUserDetailsListRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiGetUserDetailsList(requestParameters.firstName, requestParameters.lastName, requestParameters.maxJoinedOn, requestParameters.maxLastLoginDate, requestParameters.maxQuestionsCreated, requestParameters.maxReferrals, requestParameters.minJoinedOn, requestParameters.minLastLoginDate, requestParameters.minQuestionsCreated, requestParameters.minReferrals, requestParameters.pageNo, requestParameters.pageSize, requestParameters.skillId, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiGetUserGeoOptions(options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiGetUserGeoOptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiGetUsersWithAdvancedSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiGetUsersWithAdvancedSearch(requestParameters: GeneralApiApiGeneralApiGetUsersWithAdvancedSearchRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiGetUsersWithAdvancedSearch(requestParameters.competitionId, requestParameters.inactiveSince, requestParameters.maxAccuracy, requestParameters.maxCategoryLevel, requestParameters.maxCredits, requestParameters.maxRank, requestParameters.maxScore, requestParameters.minAccuracy, requestParameters.minCategoryLevel, requestParameters.minCredits, requestParameters.minRank, requestParameters.minScore, requestParameters.nameQuery, requestParameters.pageNo, requestParameters.pageSize, requestParameters.skillId, requestParameters.sortBy, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiHealthCheck(options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiHealthCheck(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiListMyFeedbacksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiListMyFeedbacks(requestParameters: GeneralApiApiGeneralApiListMyFeedbacksRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiListMyFeedbacks(requestParameters.pageNo, requestParameters.pageSize, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiLocationAutocompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiLocationAutocomplete(requestParameters: GeneralApiApiGeneralApiLocationAutocompleteRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiLocationAutocomplete(requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiMergeSimilarOrDuplicateEnititesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiMergeSimilarOrDuplicateEnitites(requestParameters: GeneralApiApiGeneralApiMergeSimilarOrDuplicateEnititesRequest, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiMergeSimilarOrDuplicateEnitites(requestParameters.mergeDuplicateEntityBody, requestParameters.entityType, requestParameters.mainEntityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiPublicLandingStats(options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiPublicLandingStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiQuestionAuthorAutocompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiQuestionAuthorAutocomplete(requestParameters: GeneralApiApiGeneralApiQuestionAuthorAutocompleteRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiQuestionAuthorAutocomplete(requestParameters.page, requestParameters.pageSize, requestParameters.query, requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiReplyToMyFeedbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiReplyToMyFeedback(requestParameters: GeneralApiApiGeneralApiReplyToMyFeedbackRequest, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiReplyToMyFeedback(requestParameters.feedbackId, requestParameters.feedbackReplyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiRewardEmployerFeedbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiRewardEmployerFeedback(requestParameters: GeneralApiApiGeneralApiRewardEmployerFeedbackRequest, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiRewardEmployerFeedback(requestParameters.feedbackId, requestParameters.rewardEmployerFeedbackBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiSendAbekusCoreFiles(options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiSendAbekusCoreFiles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiSplitEntitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiSplitEntities(requestParameters: GeneralApiApiGeneralApiSplitEntitiesRequest, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiSplitEntities(requestParameters.splitEntityBody, requestParameters.entityType, requestParameters.mainEntityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiTestCoreTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiTestCoreTask(requestParameters: GeneralApiApiGeneralApiTestCoreTaskRequest, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiTestCoreTask(requestParameters.queueName, requestParameters.taskName, requestParameters.entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiUpdateUserFeedbackStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiUpdateUserFeedbackStatus(requestParameters: GeneralApiApiGeneralApiUpdateUserFeedbackStatusRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiUpdateUserFeedbackStatus(requestParameters.feedbackId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralApiApiGeneralApiUploadFeedbackMediaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalApiUploadFeedbackMedia(requestParameters: GeneralApiApiGeneralApiUploadFeedbackMediaRequest, options?: RawAxiosRequestConfig) {
        return GeneralApiApiFp(this.configuration).generalApiUploadFeedbackMedia(requestParameters.mediaFile, options).then((request) => request(this.axios, this.basePath));
    }
}

